import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { logout, getUserDetails } from './actions/userActions';
//import store from './store';
import HomePage from './components/HomePage';
import BlogList from './components/BlogList';
import BlogPost from './components/Blog';
import AllCalculators from './components/AllCalculators';
import MathComponent from './components/Algebralab';
import FunctionGraph from './components/Algebralab3';
import SolveEquation from './components/Algebralab4';
import SolveEquationSteps from './components/Algebralab5';
import Sketch from './components/Physicslab1';
import MomentumSketch from './components/Physicslab2';
import WaveSketch from './components/Physicslab3';
import RefractionSketch from './components/Physicslab4';
import PeriodicTable from './components/Chemlab';
import LoginForm from './components/Login';
import RegisterForm from './components/Registration';
import Register from './components/Register';
import SocialMedia from './components/SocialMedia';
import Header from './components/Header';
import Footer from './components/Footer';
import WaveInterference from './components/Physicslab5';
//import LockdownBrowser from './components/Lockdownbrowser';
//import Exam from './components/Exam';
import CoursesPage from './components/Courses';
import AssessmentPage from './components/AssesmentPage';
import CourseDetailPage from './components/CourseDetails';
import DrawingBoard from './components/Whiteboard';
import SetSimulator from './components/Algebralab2';
import Profile from './components/Profile';
import Cart from './components/Cart';
import UnitConversion from './components/UnitConversionlab';
import CATAssessmentPage from './components/CATassessmentpage';
import LoopVisualizer from './components/Loop';
import InteractiveLabs from './components/InteractiveLabs';
import AdaptiveAssessments from './components/adaptive_lists_assessments';
import QuestionCreateForm from './components/createQuestion';
import Checkout from './components/Checkoutpage';
import AssessmentReviewPage from './components/Assessmentresponse';
import ContactUsPage from './components/Contactus';
import AboutUs from './components/AboutUs';
import MoleculeViewer from './components/MoleculeViewer';
import Videolist from './components/Videolist';
import MatrixM from './MatrixMultiplication';
import VideoDetail from './components/Video';
import MolecularEditor from './components/chem';
import ThreeComponent from './Bohr_model_three';
import MatrixMultiplication from './MatrixMultiplication';
import LabThreeComponent from './lab_three_component';
import useSound from './Sound';

function App() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const dispatch = useDispatch();
  
  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;
  const playClickSound = useSound('/ui-click-43196.mp3'); // Local file path
  

  useEffect(() => {
    if (!user || !user.id) {
      const userId = userInfo ? userInfo.id : null;
      if (userId) {
        dispatch(getUserDetails(userId));
      }
    }
  }, [dispatch, userInfo, user]);

  const logoutHandler = () => {
    dispatch(logout());
    playClickSound();
  };

  // Calculate the number of items in the cart
  const cartItemCount = cartItems.length;


  return (
    <Router>
      <SocialMedia />
      
      <Navbar className="navbar" expand="lg">
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
            <Nav.Link href="/#Home" onClick={playClickSound} className="text-white">Home</Nav.Link>
            <Nav.Link href="/videos" onClick={playClickSound} className="text-white">Videos</Nav.Link>
            <Nav.Link href="/InteractiveLabs#Interactive" onClick={playClickSound} className="text-white">Interactive Labs</Nav.Link>
            <Nav.Link href="/AdaptiveAssessments#Assessments" onClick={playClickSound} className="text-white">Assessments</Nav.Link>
            {userInfo ? (
              <NavDropdown className="text-white" title={userInfo.name} id='username'>
                <LinkContainer to={`/Profile/${userInfo.id}`}>
                  <NavDropdown.Item onClick={playClickSound} className="text-black">Profile</NavDropdown.Item>
                </LinkContainer>
                <NavDropdown.Item className="text-black" onClick={logoutHandler}>Logout</NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link href="/Login#LoginForm" onClick={playClickSound} className="text-white">Login</Nav.Link>
            )}
            {!userInfo && (
              <Nav.Link href="/Register#RegistrationForm" onClick={playClickSound} className="text-white">Sign Up</Nav.Link>
            )}
            {userInfo && !user?.has_active_subscription && (
              <Nav.Link href="/Cart" onClick={playClickSound} className="text-silver">
                Become a premium member!
              </Nav.Link>
            )}
            <Nav.Link onClick={playClickSound} href="/About#About" className="text-white">About us</Nav.Link>
            <Nav.Link onClick={playClickSound} href="/Contact#Contact" className="text-white">Contact Us</Nav.Link>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="white-space"></div>

      <Header />

      <Routes>
      <Route path="/cart" element={<Cart />} />
        <Route path="/videos" element={<Videolist/>} />
        <Route path="/" element={<HomePage />} />
        <Route path="/Blog" element={<BlogList />} />
        <Route path="/Whiteboard" element={<DrawingBoard />} />
        <Route path="/posts/:postId" element={<BlogPost />} />
        <Route path="/InteractiveLabs" element={<InteractiveLabs />} />
        <Route path="/Calculators" element={<AllCalculators />} />
        <Route path="/Algebralab" element={<MathComponent />} />
        <Route path="/Algebralab2" element={<SetSimulator />} />
        <Route path="/Algebralab3" element={<FunctionGraph />} />
        <Route path="/Algebralab4" element={<SolveEquation />} />
        <Route path="/Algebralab5" element={<SolveEquationSteps />} />
        <Route path="/Unit Conversions" element={<UnitConversion />} />
        <Route path="/Physicslab1" element={<Sketch />} />
        <Route path="/Physicslab2" element={<MomentumSketch />} />
        <Route path="/Physicslab3" element={<WaveSketch />} />
        <Route path="/Physicslab4" element={<RefractionSketch />} />
        <Route path="/Physicslab5" element={<WaveInterference />} />
        <Route path="/Physicslab5" element={<WaveInterference />} />
        <Route path="/MoleculeViewer" element={<MoleculeViewer />} />
        <Route path="/Chemlab" element={<PeriodicTable />} />
        <Route path="/Login" element={<LoginForm />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/Courses" element={<CoursesPage />} />
        <Route path="/assessments/:assessmentId" element={<AssessmentPage />} />
        <Route path="/catassessments/:assessmentId" element={<CATAssessmentPage />} />
        <Route path="/courses/:courseId" element={<CourseDetailPage />} />
        <Route path='/Profile/:id' element={<Profile />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/Programming' element={<LoopVisualizer />} />
        <Route path='/AdaptiveAssessments' element={<AdaptiveAssessments />} />
        <Route path='/QuestionCreate' element={<QuestionCreateForm />} />
        <Route path='/Contact' element={<ContactUsPage />} />
        <Route path='/assessment_review/:assessmentResponseId' element={<AssessmentReviewPage />} />
        <Route path='/About' element={<AboutUs />} />
        <Route path='/Matrix' element={<MatrixMultiplication />} />
        <Route path='/lectures/:videoId' element={<VideoDetail />} />
        <Route path='/chemstuff' element={<MolecularEditor />} />
        <Route path='/Atom' element={<ThreeComponent />} />
        <Route path='/MM' element={<MatrixM />} />
        <Route path='/labcomponent' element={< LabThreeComponent />} />
 



        

      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
